import React, { Fragment } from "react";
import { translate } from "../Services/translation";
import constants from "../constants";

const stylebtn = {
    "margin": "2%",
  };

const PricelistForm = ({
    errors = {},
    result = {},
    isclear=false,
    onDismiss,
    onSubmit,
  }) => (
    <div>
      <h2>{translate("mypage.pricelistexport.title")}</h2>
  
      <div className="row">
        <label className="form__label" htmlFor="productlist">
          {translate("mypage.pricelistexport.note")}
        </label>
      </div>
      
  
      {errors.general && (
        <div >{translate("mypage.pricelistexport.message")}</div>
      )}
       {result.exportlink && !isclear &&(
     
        <div className="columns small-12 medium-8" >
          {translate("mypage.pricelistexport.message")} 
        </div>
     
       )}
        {isclear &&(
     <div className="columns small-12 medium-8" >
       {translate("mypage.pricelistexport.startmessage")} 
     </div>
    )}
    
      {result.exportlink && !isclear &&(
        
          <a 
          id="exportlink"
          className="form__button"
          href={result.exportlink}     
           style={stylebtn} 
           //onClick={() => onSubmit()}
           >
          {translate("mypage.pricelistexport.download")+"("+result.exported_on+")"}
        </a>
      )}
      {
        <button
          className="form__button"    
          onClick={() => onSubmit()}
        >
          {translate("mypage.pricelistexport.genarateexcel")}
        </button>
      }
    </div>
  );
  
  export default PricelistForm;